var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 9,
  height: 19,
  fill: "none",
  viewBox: "0 0 9 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2.074 19h3.463v-8.01h3.12L9 7.01H5.537V5c0-.552.388-1 .866-1H9V0H6.403c-2.39 0-4.329 2.239-4.329 5v2.01H.343L0 10.99h2.074z"
})));
export { SvgFacebook as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxOSIgdmlld0JveD0iMCAwIDkgMTkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yLjA3NDE4IDE5SDUuNTM3MTFWMTAuOTkwMUg4LjY1NzI2TDkgNy4wMDk3N0g1LjUzNzExVjVDNS41MzcxMSA0LjQ0NzcyIDUuOTI0NjkgNCA2LjQwMjgzIDRIOVYwSDYuNDAyODNDNC4wMTIxNCAwIDIuMDc0MTggMi4yMzg1OCAyLjA3NDE4IDVWNy4wMDk3N0gwLjM0MjczMUwwIDEwLjk5MDFIMi4wNzQxOFYxOVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";